module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[78]77.44b6071.woff2";